import { Component, Input, HostBinding } from '@angular/core';
import { IKpiItem } from 'src/app/models/generic';

export type KpiRowLayout = 'inline-pills' | 'strip' | 'grid' | 'cards';

@Component({
  selector: 'app-kpi-row',
  templateUrl: './kpi-row.component.html',
  styleUrls: ['./kpi-row.component.scss']
})
export class KpiRowComponent {
  @Input() items: IKpiItem[] = [];
  @Input() layout: KpiRowLayout = 'inline-pills';
  @Input() dense = false;

  @HostBinding('class') get hostClass(): string {
    return [
      'ui-kpi-row',
      `ui-kpi-row--${this.layout}`,
      this.dense ? 'ui-kpi-row--dense' : ''
    ].join(' ').trim();
  }
}
